export default "__VITE_ASSET__N1P2d_0y_wfARkZ2MnXKCA__"